import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class EmailDeliveriesResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "email_deliveries", `/api/v1/email_deliveries`);
  }
}
